/**
 * Normaliza texto removiendo acentos/tildes y convirtiendo a minúsculas.
 * Útil para búsquedas accent-insensitive (ej: "máquina" → "maquina", "José" → "jose").
 */
const normalizeText = (text) =>
    text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export default normalizeText;
